<template>
  <div>
    <el-row style="margin-bottom: 10px;" :hidden="tagValueList.length ==0">
      <el-tag
              :key="index"
              v-for="(tag,index) in tagValueList"
              closable
              :disable-transitions="false"
              @close="handleTagDelete(tag)">
        {{tag}}
      </el-tag>
    </el-row>
    <el-row>
      <template v-if="inputVisible">
          <el-autocomplete
                  class="input-new-tag"
                  v-model="inputValue"
                  :fetch-suggestions="querySearch"
                  ref="saveTagInput"
                  size="small"
                  clearable
                  :placeholder="$t('commons.pleaseInput')"
                  @select="handleSelect"
                  @keyup.enter.native="handleInputConfirm">
          </el-autocomplete>
          <el-button type="success" @click="handleInputConfirm" icon="el-icon-check" size="mini" style="margin-left: 10px;" circle></el-button>
          <el-button type="danger" icon="el-icon-close" @click="inputVisible = false" size="mini" style="margin-left: 10px;" circle></el-button>
      </template>
      <el-button v-else class="button-new-tag" type="success" size="small" @click="showInput">+ {{$t('tag.create')}}</el-button>
    </el-row>
  </div>
</template>

<script>
import {getTagList} from '@/api/iori/tag'

export default {
  name: 'TagBind',
  props: {
    tagValueList: {
      type: Array,
      required: true
    },
    tagType: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      tagList:[],
      inputVisible:false,
      inputValue:'',
      listQuery:{
        //分页参数
        current:1,
        rowCount:20,
        resultMode:2,
        tagType:null
      },
    }
  },
  methods :{
    initTagList(){
      this.listQuery.tagType = this.tagType;
      return getTagList(this.listQuery).then(res=>{
        this.tagList = [];
        let tagList = [];
        res.rows.map(v=>{
          tagList.push(v.tagName);
        })
        let tagValueList = this.tagValueList;
        let set1 = new Set(tagList);
        let set2 = new Set(tagValueList);
        let dfrcset = [...new Set([...set1].filter(x => !set2.has(x)))];
        dfrcset.map(v=>{
          this.tagList.push({"value":v});
        })
      }).catch(error =>{
        console.log(`查询失败，原因=> ${error}`)
      })
    },
    //删除标签页
    handleTagDelete(tag){
      if(this.tagList.findIndex(item => item.value == tag) == -1){
        this.tagList.push({"value":tag});
      }
      this.tagValueList.splice(this.tagValueList.indexOf(tag), 1);
    },
    showInput() {

      this.inputValue = '';
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue.trim();
      if (inputValue) {
        this.tagValueList.push(inputValue);
        this.inputVisible = false;
      }
      this.inputValue = '';
    },
    querySearch(queryString, cb) {
      this.initTagList().then(()=>{
        let tagList = this.tagList;
        let results = queryString ? tagList.filter(this.createFilter(queryString)) : tagList;
        // 调用 callback 返回建议列表的数据
        cb(results);
      });
    },
    createFilter(queryString) {
      return (tag) => {
        return (tag.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.inputValue = item.value.trim();
    }
  }
}
</script>

<style scoped>
  .el-tag {
    margin-right: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    vertical-align: bottom;
  }
</style>
